import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetAlertByIdQuery,
  GetAlertByIdQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { alertFragment } from "src/graphql/anti-fraud/fragments/AlertFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToAlert } from "src/mappers/alert.mappers";

export const getAlertById = gql`
  query GetAlertById($id: ID!) {
    alert(id: $id) {
      ...AlertFragment
    }
  }

  ${alertFragment}
` as TypedDocumentNode<GetAlertByIdQuery, GetAlertByIdQueryVariables>;

export const useGetAlertById = (options: { id: string | undefined }) => {
  return useFetchQuery(getAlertById, {
    isEmpty: (data) => !data,
    toData: (data) => data?.alert && mapToAlert(data.alert),
    queryOptions: {
      variables: { id: options.id ?? "" },
      skip: !options.id,
    },
    uiErrors: {
      fetchError: "FETCH-ALERTS-ERROR",
    },
  });
};
